import React from "react";
import "./Footer.css";

const Footer = () => {
	const links = [
		{ title: "وبسایت دانشگاه", href: "https://www.kntu.ac.ir/" },
		{ title: "راهنما", href: "#"}
	];

	return (
		<footer className="site-footer">
			<div className="footer-container">
				<div className="footer-grid">
					<div className="footer-section">
						<h3 className="footer-heading">
							دانشگاه صنعتی خواجه نصیرالدین طوسی
						</h3>
						<div className="social-links">
							<ul className="footer-links">
								{links.map((link) => (
									<li>
										<a
											href={link.href}
											className="footer-link"
										>
											{link.title}
										</a>
									</li>
								))}
							</ul>
						</div>
					</div>
					<div className="footer-section">
						<h3 className="footer-heading">تماس با ما</h3>
						<address className="footer-address">
							تهران، میدان ونک، خیابان ملاصدرا، خیابان پردیس، پلاک
							۱۵-۱۹
							<br />
							<span>کد پستی:</span> ۱۹۹۱۹۴۳۵۸۱
						</address>
						<p className="footer-text">
							<div>
								<div>
									<span>تلفن:</span>۸۴۰۶۴۰۰۰-۰۲۱
								</div>
								<div>
									<span>ایمیل:</span>info@kntu.ac.ir
								</div>
							</div>
						</p>
					</div>
				</div>
				<div className="footer-copyright">
					<p>
						© {new Date().getFullYear()} دانشگاه صنعتی خواجه
						نصیرالدین طوسی. تمامی حقوق محفوظ است.
					</p>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
